import type { SxProps } from '@mui/material'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/system'
import { useEffect, useState } from 'react'

import { LuneTheme } from '../theme'

import Loading from './Loading'

const LABEL_INTERVAL_MS = 5000
const LoadingWrapper = ({
    loading,
    labels,
    children,
    className,
    bigLoader,
    light,
    sx,
    ...rest
}: {
    loading?: boolean
    labels?: string[]
    children: React.ReactNode
    className?: string
    bigLoader?: boolean
    light?: boolean
    sx?: SxProps
}) => {
    const spacing = LuneTheme.spacing
    const LoaderWrapper = styled('div')(
        LuneTheme.unstable_sx({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: spacing(2),
        }),
    )

    const StyledLoading = styled(Loading)(
        LuneTheme.unstable_sx({
            height: bigLoader ? spacing(8) : spacing(4),
            width: bigLoader ? spacing(8) : spacing(4),
        }),
    )

    const [currentLabelIndex, setCurrentLabelIndex] = useState(0)
    useEffect(() => {
        if (!labels || labels.length === 0) return

        const interval = setInterval(() => {
            setCurrentLabelIndex((prev) => (prev + 1) % labels.length)
        }, LABEL_INTERVAL_MS)

        return () => clearInterval(interval)
    }, [labels])

    return loading ? (
        <LoaderWrapper className={className} {...rest} sx={sx}>
            <StyledLoading light={light} />
            {labels && labels.length > 0 && (
                <Typography sx={{ color: LuneTheme.palette.Grey900 }} variant="body2">
                    {labels[currentLabelIndex]}
                </Typography>
            )}
        </LoaderWrapper>
    ) : (
        <>{children}</>
    )
}

export default LoadingWrapper
